<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="Loaderstatus"
		>
			<Spinner />
		</div>
		<div :class="{ 'form-disabled': isUploadLocked }">
			<div class="secsub-left-quescontainer">
				<div class="sec-addquescontainer">
					<div class="d-flex">
						<div style="width: 40%" class="sec-addques-headtxt">MTF</div>
						<div
							style="width: 20%"
							class="topDiv relativeclass ckeditor ques-tag-form-control w-40"
						>
							<b-form-tags
								v-model="questions.questionTags"
								no-outer-focus
								remove-on-delete
								ref="questionTagref"
								separator=" "
							>
								<template
									v-slot="{
										tags,
										inputAttrs,
										inputHandlers,
										tagVariant,

										removeTag,
									}"
								>
									<b-input-group class="cust-group-input" id="addcontainer-tag">
										<div class="d-flex no-wrap">
											<div
												class="d-inline-block cust-btn-select"
												style="font-size: 1.5rem"
											>
												<b-form-tag
													v-for="tag in tags"
													@remove="removeTag(tag)"
													:key="tag"
													:title="tag"
													:variant="tagVariant"
													class="mr-1 ml-2"
													>{{ tag }}</b-form-tag
												>
											</div>
											<b-form-input
												id="input-tag"
												v-bind="inputAttrs"
												v-on="inputHandlers"
												@keyup="hashtag()"
												placeholder="Enter Question tag"
												class="form-control min-width mr-4 ml-2"
											></b-form-input>
										</div>
									</b-input-group>
								</template>
							</b-form-tags>
						</div>
						<div class="relativeclass ml-2" ref="showdiffoptions">
							<div
								v-if="showdiffoptions"
								class="diff-dropdown d-flex"
								ref="showdiff"
								v-closable="{
									exclude: ['showdiffoptions', 'showdiff'],
									handler: 'hidediffoptions',
								}"
							>
								<b-form-group class="sec-mcq-datacard">
									<b-form-radio-group
										class="text-align-center"
										id="btn-radios-3"
										:options="options"
										value-field="value"
										text-field="text"
										name="radio-btn-stacked"
										@change="showdiffoptions = !showdiffoptions"
										buttons
										stacked
										v-model="$v.questions.difficultyLevel.$model"
									></b-form-radio-group>
								</b-form-group>
							</div>
							<div
								class="sec-addquesbox-rightside input-placeholder"
								@click="showdiffoptions = !showdiffoptions"
							>
								<b-form-input
									style="background: transparent"
									class="pointer"
									readonly
									:class="{
										error: $v.questions.difficultyLevel.$error,
									}"
								>
								</b-form-input>
								<div class="placeholder" ref="showdiffoptions1">
									Difficulty Level {{ questions.difficultyLevel
									}}<span v-if="questions.difficultyLevel == ''">*</span>
								</div>
								<div
									style="position: absolute; top: 5px; right: 2vw"
									v-if="
										$v.questions.difficultyLevel.$dirty &&
											!$v.questions.difficultyLevel.required
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div class="diff-downarrow">
									<img
										v-if="!showdiffoptions"
										src="../../assets/assess-main-downArrow.svg"
										alt=""
										class="mr-2 pointer"
									/>
									<img
										v-else
										class="mr-2 pointer"
										src="../../assets/assess-main-upArrow.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
						<div style="width: 20%" class="relativeclass ml-2">
							<b-form-input
								v-model.trim="$v.questions.marks.$model"
								:class="{
									error: $v.questions.marks.$error,
								}"
								@keypress="validateMarks($event)"
							>
							</b-form-input>
							<div
								class="placeholder"
								v-if="questions.marks == null || !$v.questions.marks.required"
							>
								Marks <span>*</span>
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="$v.questions.marks.$dirty && !$v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="!$v.questions.marks.alpha && $v.questions.marks.required"
								v-b-popover.hover.top.v-danger="{
									content: 'Accepts only 2 digit after decimal point',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 5px; right: 12px"
								v-if="
									!$v.questions.marks.between && $v.questions.marks.required
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should be between (0.5, 100)',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>
					<div class="mt-2">
						<div class="topDiv mt-3 relativeclass">
							<div
								:class="
									dirtyMtfQuestion ||
									(!$v.questions.question.maxLength && !dirtyMtfQuestion)
										? 'error'
										: ''
								"
							>
								<label class="addquesboxfieldsetStyle" style="z-index: 4">
									Question &nbsp;<span class="asterik">*</span></label
								>
								<QuillEditor
									:addquesProp="addques"
									:value="$v.questions.question.$model"
									@validationVal="validateText"
									@questionText="updateQuestionContent"
									@addquesBack="changedaddQues"
								>
								</QuillEditor>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="dirtyMtfQuestion && $v.questions.question.required"
									v-b-popover.hover.top.v-danger="{
										content: 'Required',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 10px; right: 20px"
									v-if="!$v.questions.question.maxLength && !dirtyMtfQuestion"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 10000 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>

							<div class="media-box mt-2 align-items-center">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex align-items-center">
										<div class="media-text ml-3">Add Media</div>
										<div class="ml-2">
											<img src="../../assets/vertical-line.svg" alt="" />
										</div>
										<div class="d-flex align-items-center ml-2 mt-1">
											<div
												class="ml-2"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Audio supported formats are: wav, mp3"
											>
												<label for="file-upload" class="pointer">
													<img src="../../assets/headphone.svg" alt="" />
												</label>
												<input
													id="file-upload"
													type="file"
													accept="audio/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title=" Video supported formats is: mp4"
											>
												<label for="file-upload-video" class="pointer">
													<img src="../../assets/videocam.svg" alt="" />
												</label>
												<input
													id="file-upload-video"
													type="file"
													accept="video/*"
													@change="previewFile"
												/>
											</div>
											<div
												class="ml-3"
												v-b-tooltip.hover="{ variant: 'secondary' }"
												title="Image supported formats are: jpg, jpeg, png"
											>
												<label for="file-upload-image" class="pointer">
													<img src="../../assets/image-capture.svg" alt="" />
												</label>
												<input
													id="file-upload-image"
													type="file"
													accept="image/*"
													@change="previewFile"
												/>
											</div>
										</div>
									</div>

									<div
										class="d-flex align-items-center"
										v-if="questions.isFailed"
									>
										<img src="../../assets/Vector.svg" alt="" class="mr-2" />
										<p class="uploadfailed mb-0 mr-2">Invalid media file</p>
									</div>
								</div>
							</div>

							<div
								style="position: absolute; top: 10px; right: 20px"
								v-if="dirtyMtfQuestion && !$v.questions.question.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>

						<!-- below div comes if image exists -->
						<template v-if="checkMedia">
							<div
								v-if="isImage(questions.questionMediaType)"
								class="mt-2 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<img
										:src="questions.questionMedia"
										alt=""
										class="dbmcqcardimage"
									/>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>

							<!-- below div comes if audio exists -->
							<div
								v-if="isAudio(questions.questionMediaType)"
								class="d-flex mt-2"
							>
								<div class="d-flex align-items-center mr-5">
									<img src="../../assets/audio.svg" alt="" />
									<span class="ml-2"> Audio</span>
								</div>
								<div class="d-flex align-items-center relativeclass">
									<Media
										:kind="'audio'"
										:isMuted="false"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="mcqdatacard-audio"
										:src="questions.questionMedia"
									></Media>
									<div class="mcq-audioxmark pointer" @click="removeMedia()">
										<img src="../../assets/xmark.svg" alt="" />
									</div>
								</div>
							</div>
							<div
								v-if="isVideo(questions.questionMediaType)"
								class="mt-3 d-flex align-items-center justify-content-center"
							>
								<div class="relativeclass">
									<Media
										:kind="'video'"
										:isMuted="false"
										:src="questions.questionMedia"
										:autoplay="false"
										:controls="true"
										:loop="true"
										class="dbmcqcardimage"
									></Media>
									<div @click="removeMedia()" class="xMarkImageCancel">
										<img
											src="../../assets/icons/Qpbuilder/imagecloseicon.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</template>
						<b-row v-if="showVideoUploading">
							<b-col class="ab-uploaded-card w-100 mt-3">
								<b-card no-body class="d-flex w-100">
									<section class="d-flex align-items-center pt-1">
										<div
											class="ab-uploaded-file-heading d-flex align-items-center w-75"
										>
											{{ videoData.name }}
										</div>

										<div
											class="ab-uploaded-file-subheading w-20 d-flex justify-content-end align-items-center gap-2"
										>
											<b-spinner
												v-if="showSpinner"
												label="Spinning"
											></b-spinner>
											<span>{{ formatSize(videoData.size) }}</span>
											<!-- <span class="ml-2"> 2 sec Left</span> -->
										</div>
										<!-- 
									<img
										:class="progress <= 0 ? 'opacity-50' : 'pointer'"
										@click="progress > 0 ? removeFile('video') : ''"
										class="ml-3"
										src="@/assets/common/blue-cross.svg"
										alt=""
									/> -->
									</section>
									<section class="mt-2">
										<b-progress height="4px" :value="progress"></b-progress>
									</section>
								</b-card>
							</b-col>
						</b-row>
						<div class="mt-3 mb-3 sec-quesbox-radios mcq-form-option">
							<div
								class="d-flex align-items-center p-2 w-100"
								v-for="(option, index) of questions.answerKey"
								:key="index"
							>
								<div style="width: 45%">
									<div class="topDiv relativeclass">
										<label class="addquesboxfieldsetStyle"
											>Match {{ index + 1 }}&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="addquesboxinputField"
											placeholder="Enter here"
											type="text"
											v-model.trim="option.sideA"
										></b-form-input>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.questions.answerKey.$each[index].sideA.$dirty &&
													!$v.questions.answerKey.$each[index].sideA.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.questions.answerKey.$each[index].sideA.required &&
													!$v.questions.answerKey.$each[index].sideA.maxLength
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 1024 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</div>
								<div
									:style="
										questions.answerKey.length > 3 ? 'width:7%' : 'width:10%'
									"
								>
									<div class="d-flex align-items-center justify-content-center">
										<img src="../../assets/matchoption.svg" alt="" />
									</div>
								</div>
								<div style="width: 45%">
									<div class="topDiv relativeclass">
										<label class="addquesboxfieldsetStyle"
											>Match {{ index + 1 }}&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="addquesboxinputField"
											placeholder="Enter here"
											type="text"
											v-model.trim="option.sideB"
										></b-form-input>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.questions.answerKey.$each[index].sideB.$dirty &&
													!$v.questions.answerKey.$each[index].sideB.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												$v.questions.answerKey.$each[index].sideB.required &&
													!$v.questions.answerKey.$each[index].sideB.maxLength
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 1024 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</div>

								<div
									v-if="questions.answerKey.length > 3"
									style="width: 3%"
									class="d-flex align-items-center pointer justify-content-end"
								>
									<img
										src="../../assets/deleteicon.svg"
										alt=""
										@click="deletematchoptions(index)"
									/>
								</div>
							</div>
							<div class="asterik" v-if="moreOption">
								Cannot add more than 8 options<span class="asterik">*</span>
							</div>
						</div>
					</div>
				</div>

				<div
					class="sec-addquescheckboxcontainer m-3 d-flex justify-content-between"
				>
					<div class="d-flex align-items-center">
						<div
							@click="addInput()"
							class="d-flex align-items-center pointer mb-3"
						>
							<img src="../../assets/secplusicon.svg" alt="" />
							<div class="sec-addquestext ml-2">Add more Matches</div>
						</div>
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="questions.autoCorrection"
						>
							Auto Evaluation
						</b-form-checkbox>
						<b-form-checkbox
							class="ml-3 sec-checboxtext"
							v-model="questions.required"
						>
							Mandatory question
						</b-form-checkbox>
					</div>
					<div class="d-flex pointer relativeclass">
						<div class="sec-addcheckboxtext mr-3" ref="showdatacard1">
							<span @click="type == 'mtf' ? addquestion() : addautomafo()"
								>Add</span
							>
						</div>
						<div @click="clearData()" class="sec-canceltext-active">Cancel</div>
						<div
							v-if="showdatacard"
							ref="showdatacard"
							v-closable="{
								exclude: ['showdatacard', 'showdatacard1'],
								handler: 'hidedatacard',
							}"
						>
							<div class="sec-adddata-card d-flex align-items-center">
								<b-form-group class="sec-mcq-datacard">
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToDatabank"
										name="flavour-4a"
									>
										Add to Questionbank
									</b-form-checkbox>
									<b-form-checkbox
										class="qb-dropdown-option-sing"
										size="sm"
										v-model="questions.addToPublic"
										name="flavour-4a"
									>
										Add to public
									</b-form-checkbox>
								</b-form-group>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="attachdocs"
			v-model="uploadModal"
			centered
			hide-footer
			hide-header
			@show="resetModal"
			@hidden="resetModal"
		>
			<div @click="closeattachdocsmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="relativeclass sec-attachdocs">
				<div class="dot-main">
					<div
						class="d-flex align-items-center justify-content-center flex-column"
					>
						<div class="sec-attachdocs-text d-flex flex-column mt-2 pointer">
							<div>
								<label for="file-upload" class="custom-file-upload pointer">
									<div class="d-flex flex-column align-items-center">
										<img
											src="../../assets/icons/Qpbuilder/uploadicon.svg"
											alt=""
										/>
										Click to browse or drag <br />and drop your files
									</div>
								</label>
								<input id="file-upload" type="file" @change="previewFile" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import QuillEditor from "./quillEditor.vue"; //Quill editor from component
import Spinner from "../../components/fixedcomponents/Spinner.vue";

import { isImage, isVideo, isAudio } from "../../utils/checkFileType";

import {
	required,
	helpers,
	between,
	maxLength,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import toast from "../../views/mixin/toast";
import { postMatchTheFollowingQuestionv2 } from "../../utils/apiFunctions";
import mediaUploadMixin from "@/views/mixin/mediaUploadMixin";
import socketUploadMixin from "@/views/mixin/socketUploadMixin";
export default {
	name: "MatchTheFollowing",
	mixins: [toast, mediaUploadMixin, socketUploadMixin],
	props: {
		type: String,
		autosectionID: String,
		questions: Object,
	},
	components: {
		// Media
		QuillEditor, //From quill component
		Spinner,
	},
	data() {
		return {
			showVideoUploading: false, // controls ab-uploaded-card visibility
			progress: 0, // progress bar value
			videoData: {}, // { name, size }
			showSpinner: false, // spinner near size
			addques: false,
			moreOption: false,
			dirtyMtfQuestion: false,
			Loaderstatus: false,
			showdiffoptions: false,
			uploadModal: false,
			checkMedia: false,
			showdatacard: false,
			isFailed: false,
			optionnum: 1,
			options: [
				{
					value: "1",
					text: "Difficulty Level 1",
				},
				{
					value: "2",
					text: "Difficulty Level 2",
				},
				{
					value: "3",
					text: "Difficulty Level 3",
				},
				{
					value: "4",
					text: "Difficulty Level 4",
				},
				{
					value: "5",
					text: "Difficulty Level 5",
				},
			],

			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-","insertTable"],
			},
		};
	},
	watch: {
		// "questions.question"(newValue, oldValue) {
		//   if (newValue == oldValue || oldValue == "") {
		//     this.dirtyMtfQuestion = true;
		//   }
		// },

		selectedSection(newValue, oldValue) {
			if (newValue != oldValue) {
				this.questions.questionMediaType = "";
				this.questions.questionMedia = "";
			}
		},
	},
	computed: {
		isUploadLocked() {
			return this.showVideoUploading;
		},
		...mapGetters("sectionVUEX", {
			selectedSection: "getSelectedSection",
			questionAdded: "getQuestionAdded",
		}),
		...mapGetters("autotestVUEX", {
			autoselectedSection: "getSelectedSection",
			topicID: "getAutoTopicID",
		}),
	},
	validations: {
		questions: {
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},

			difficultyLevel: {
				required,
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			answerKey: {
				$each: {
					sideA: {
						required,
						maxLength: maxLength(1024),
					},
					sideB: {
						required,
						maxLength: maxLength(1024),
					},
				},
			},
		},
	},

	created() {
		if (this.questions.file && this.questions.questionMedia) {
			this.checkMedia = true;
		}
	},

	methods: {
		formatSize(bytes) {
			if (!bytes && bytes !== 0) return "";

			const kb = bytes / 1024;

			if (kb < 1024) {
				return `${kb.toFixed(1)} KB`;
			}

			return `${(kb / 1024).toFixed(1)} MB`;
		},
		validateMarks(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		validateText(val) {
			this.dirtyMtfQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.questions.question = newContent;
		},
		changedaddQues(newval) {
			this.addques = newval;
		},

		//For removing Space From Top and bottom of last text of Quill Editor
		getDesiredContent() {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = this.questions.question;
			const pTags = tempDiv.querySelectorAll("p");
			let endIndex = pTags.length;
			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}
			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});
			this.questions.question = tempDiv.innerHTML;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		isImage,
		isVideo,
		isAudio,
		hidedatacard() {
			this.showdatacard = false;
		},
		hidediffoptions() {
			this.showdiffoptions = false;
			this.showdatacard = false;
		},
		async previewFile(event) {
			const file = event.target.files[0];
			if (!file) return;
			this.videoData = {
				name: file.name,
				size: file.size,
			};
			await this.handleMediaUpload(event, this.questions);

			this.questions.file = this.questions.questionFile;

			this.checkMedia = !this.questions.isFailed;
		},
		scrollToRight() {
			const scrollContainer = document.getElementById("addcontainer-tag");
			scrollContainer.scrollTo({
				top: 0,
				left: scrollContainer.scrollWidth,
				behavior: "smooth",
			});
		},
		addquestiontag() {
			const el1 = document.getElementById("add-tag");
			el1.addEventListener("click", this.scrollToRight, false);
		},

		async addautomafo() {
			if (this.questions.file) {
				this.showVideoUploading = true;
			}
			this.showSpinner = true;
			let bucketPath = null;

			if (this.questions.file && this.questions.fileMeta) {
				bucketPath = await this.uploadFileViaSocket(
					this.questions.file,
					this.questions.fileMeta
				);
			}
			this.prepareFormData(bucketPath);
			try {
				const response = await this.postFormData();
				this.handleResponse(response);

				this.showVideoUploading = false;
				this.showSpinner = false;
				this.progress = 0;
				this.videoData = {};
			} catch (error) {
				this.errorToast("Something went wrong!");
			}

			// Clearing card data
			this.clearData();
		},

		prepareFormData(bucketPath) {
			this.$v.$touch();
			if (this.isValidForm()) {
				let form = new FormData();
				this.getDesiredContent();

				for (let key in this.questions) {
					if (key === "questionMedia") {
						this.handleQuestionMedia(form, bucketPath);
					} else if (key === "answerKey") {
						this.handleAnswerKey(form, key);
					} else if (key === "questionTags") {
						this.handleQuestionTags(form, key);
					} else if (key === "addToDatabank") {
						form.append("addToDatabank", true);
					} else {
						form.append(key, this.questions[key]);
					}
				}

				form.append("sectionID", this.autosectionID);
				form.append("testID", this.$route.params.testID);
				form.append("type", "ADD_QUES");
				form.append("topicID", this.topicID);
				form.append("selected", "A");
				form.append("delete", "1");

				this.formData = form;
			} else {
				this.errorToast("Please enter all the details");
			}
		},

		isValidForm() {
			return (
				!this.$v.$invalid &&
				!this.dirtyMtfQuestion &&
				this.questions.question !== ""
			);
		},

		handleQuestionMedia(form, bucketPath) {
			if (bucketPath) {
				form.append("questionMediaPath", bucketPath);
				form.append("questionMediaType", this.questions.questionMediaType);
				return;
			}

			if (!this.questions.file && this.questions.questionMedia === "") {
				form.set("delete", 1);
			} else if (!this.questions.file && this.questions.questionMedia !== "") {
				// existing media, no change
				return;
			} else {
				form.set("delete", 1);
			}
		},
		handleAnswerKey(form, key) {
			this.questions[key] = JSON.stringify(this.questions[key]);
			form.append(key, this.questions[key]);
			this.questions[key] = JSON.parse(this.questions[key]);
		},

		handleQuestionTags(form, key) {
			let questiontags = this.questions.questionTags.map((s) =>
				s[0] == "#" ? s.slice(1) : s
			);
			form.append(key, JSON.stringify(questiontags));
		},

		async postFormData() {
			return await postMatchTheFollowingQuestionv2(this.formData);
		},

		handleResponse(response) {
			if (response.status == 200) {
				this.successToast("Question added successfully!");
				this.questions.questionKey = response.data.data.QuestionID;
				this.$emit("question-added");
			} else {
				this.errorToast("Something went wrong!");
			}
		},

		addInput() {
			if (this.questions.answerKey.length >= 8) {
				this.moreOption = true;
			} else {
				this.moreOption = false;
			}
			if (!this.moreOption) {
				this.questions.answerKey.push({
					sideA: "",
					sideB: "",
				});
			}
		},
		cancelForm() {
			this.$store.dispatch("questionVUEX/getQuestions", this.selectedSection);
		},
		deletematchoptions(i) {
			this.questions.answerKey.splice(i, 1);
			this.moreOption = false;
			this.$forceUpdate();
		},
		hashtag() {
			let str = document.getElementById("input-tag").value;
			let tagged = str.replace(/#/g, "").replace(/([a-zA-Z0-9]+)/g, "#" + "$1");
			document.getElementById("input-tag").value = tagged;
		},

		async addquestion() {
			if (this.questions.file) {
				this.showVideoUploading = true;
			}
			this.showSpinner = true;
			this.$v.$touch();
			if (!this.areInputFieldsValid()) {
				this.errorToast("Please enter all the details");
				return;
			}

			try {
				let bucketPath = null;

				//  SOCKET UPLOAD FIRST
				if (this.questions.file && this.questions.fileMeta) {
					bucketPath = await this.uploadFileViaSocket(
						this.questions.file,
						this.questions.fileMeta
					);
				}

				//  now build form WITH bucketPath
				this.setupFormData(bucketPath);

				const response = await this.submitFormData();

				this.handleFormSubmissionResponse(response);
				this.showVideoUploading = false;
				this.showSpinner = false;
				this.progress = 0;
				this.videoData = {};
			} catch (error) {
				this.errorToast("Something went wrong!");
			}
		},
		setupFormData(bucketPath = null) {
			this.validateInputFields();
			if (this.areInputFieldsValid()) {
				let form = new FormData();
				this.getDesiredContent();

				for (let key in this.questions) {
					if (key === "questionFile" || key === "file" || key === "fileMeta") {
						continue;
					}
					if (key === "questionMedia") {
						if (bucketPath) {
							form.append("questionMediaPath", bucketPath);
							form.append(
								"questionMediaType",
								this.questions.questionMediaType
							);
						} else if (
							!this.questions.file &&
							this.questions.questionMedia !== ""
						) {
							continue;
						} else {
							form.append("delete", 1);
						}
						continue;
					} else if (key === "answerKey") {
						this.processAnswerKeyInput(form, key);
					} else if (key === "questionTags") {
						this.processQuestionTagsInput(form, key);
					} else {
						form.append(key, this.questions[key]);
					}
				}

				form.append("sectionID", this.selectedSection.sectionID);
				form.append("testID", this.selectedSection.testID);
				this.formData = form;
				return true;
			} else {
				this.errorToast("Please enter all the details");
				return false;
			}
		},

		validateInputFields() {
			this.$v.$touch();
		},

		areInputFieldsValid() {
			return (
				!this.$v.$invalid &&
				!this.dirtyMtfQuestion &&
				this.questions.question !== ""
			);
		},

		processQuestionMediaInput(form, key) {
			if (!this.questions.file && this.questions.questionMedia === "") {
				delete this.questions.file;
				delete this.questions.questionMedia;
				delete this.questions.questionMediaType;
				form.set("delete", 1);
			} else if (!this.questions.file && this.questions.questionMedia !== "") {
				//Do Nothing
			} else {
				form.append(key, this.questions.file);
			}
		},

		processAnswerKeyInput(form, key) {
			this.questions[key] = JSON.stringify(this.questions[key]);
			form.append(key, this.questions[key]);
			this.questions[key] = JSON.parse(this.questions[key]);
		},

		processQuestionTagsInput(form, key) {
			let questiontags = this.questions.questionTags.map((s) =>
				s[0] == "#" ? s.slice(1) : s
			);
			form.append(key, JSON.stringify(questiontags));
		},

		async submitFormData() {
			return await postMatchTheFollowingQuestionv2(this.formData);
		},

		handleFormSubmissionResponse(response) {
			if (response.status == 200) {
				this.successToast("Question added successfully!");
				this.$emit("question-added");
			} else {
				this.errorToast("Something went wrong!");
			}
		},

		removeMedia() {
			this.questions.questionMedia = "";
			this.questions.questionMediaType = "";
			this.checkMedia = false;
			this.$forceUpdate();
		},
		resetModal() {
			this.questions.isFailed = false;
		},
		clearData() {
			this.addques = true;
			this.$refs.questionTagref.reset();
			this.dirtyMtfQuestion = false;
			this.$emit("clearData");
			// clear image
			this.$v.$reset();
			this.removeMedia();
			this.moreOption = false;
		},

		//close attachdocs modal
		closeattachdocsmodal() {
			this.$bvModal.hide("attachdocs");
		},
	},
};
</script>

<style>
.input-placeholder {
	position: relative;
}
.placeholder {
	position: absolute;
	pointer-events: none;
	top: 2px;
	bottom: 2px;
	left: 6px;
	margin: auto;
	padding: 0.375rem 0.75rem;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
}
.placeholder span {
	color: red;
}
</style>
